var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportCamera66(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.2,
    height: 33.3,
    viewBox: "0 0 40.2 33.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-2_export-CAMERA-66",
    transform: "translate(-3.9 -6.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M24,36.3a10.573,10.573,0,0,0,7.7-3.2,10.739,10.739,0,0,0,3.2-7.7,10.573,10.573,0,0,0-3.2-7.7A10.739,10.739,0,0,0,24,14.5a10.573,10.573,0,0,0-7.7,3.2,10.739,10.739,0,0,0-3.2,7.7A10.926,10.926,0,0,0,24,36.3ZM15.1,25.4A8.9,8.9,0,1,1,24,34.3,8.92,8.92,0,0,1,15.1,25.4Z",
    fill: "#060707"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M24.6,21a3.9,3.9,0,0,1,3.9,3.9.8.8,0,1,0,1.6,0,5.378,5.378,0,0,0-5.4-5.4.789.789,0,0,0-.8.8C23.9,20.8,24.1,21,24.6,21Z",
    fill: "#060707"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M39.1,11.3H33.6c0-.2-.1-.3-.2-.5l-.6-1.5a4.987,4.987,0,0,0-4.6-3.1H19.7a4.987,4.987,0,0,0-4.6,3.1l-.6,1.5c-.1.2-.1.3-.2.5H8.9a5.015,5.015,0,0,0-5,5V34.5a5.015,5.015,0,0,0,5,5H39.1a5.015,5.015,0,0,0,5-5V16.3A4.951,4.951,0,0,0,39.1,11.3Zm-30.2,2h6.3a1.063,1.063,0,0,0,1-.9,1.884,1.884,0,0,1,.2-.8L17,10a2.937,2.937,0,0,1,2.7-1.8h8.5A2.837,2.837,0,0,1,30.9,10l.6,1.5a2.353,2.353,0,0,1,.2.8,1.063,1.063,0,0,0,1,.9H39a2.946,2.946,0,0,1,3,3V34.4a2.946,2.946,0,0,1-3,3H8.9a2.946,2.946,0,0,1-3-3V16.3A2.946,2.946,0,0,1,8.9,13.3Z",
    fill: "#060707"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportCamera66);
export default __webpack_public_path__ + "static/media/icons-2_export-CAMERA-66.88d2319a4ce990de920e71e1b9f33dd6.svg";
export { ForwardRef as ReactComponent };